/**
 * Max pages allowed for non-fillable PDF uploads.
 * Staging is 100 so long forms can be exercised; everywhere else (including
 * unset/unknown env) stays at 30. Keep in sync with
 * ml-scribe/shared/pymupdf/constants.py MAX_PAGES_FOR_LLM_FIELD_DETECTION.
 * Used in: form-filling-upload.tsx
 */
export const getPdfNonFillableMaxPages = (isStaging: boolean) => (isStaging ? 100 : 30);
